import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import { Offcanvas, CloseButton } from "react-bootstrap";
import { SearchIcon, InstagramIcon, FacebookIcon, XIcon, YoutubIcon, MobileMenu, MenuClose } from "../svgIcon";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import AOS from 'aos';
import axios from "axios";
import './header-main.scss';
import './menu.scss';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Filter } from "bad-words";
import { toast } from "react-toastify";

function Header({ menuObj, FrontLogo, FrontStickyLogo, Constant }) {
    const navigate = useNavigate();
    const APP_URL = window.site_url;
    const cdn_path = window.cdn_path;
    const location = useLocation();
    const filter = new Filter();
    const [show, setShow] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false); // Mobile menu state
    const [showSuggestions, setShowSuggestions] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (e) => {
        e.preventDefault();
        setShow(true)
    };
    useEffect(() => {
        if (isMenuOpen) {
            AOS.refresh(); // Refresh AOS when menu opens
        } else {
            setTimeout(() => {
                AOS.refresh(); // Refresh AOS after menu closes
            }, 50); // Adjust delay based on animation speed
        }
    }, [isMenuOpen]);
    const [openSubMenuId, setOpenSubMenuId] = useState(null);
    const handleSubMenuToggle = (id) => {
        setOpenSubMenuId((prevId) => (prevId === id ? null : id));
    };
    useEffect(() => {
        AOS.refresh();
        let lastScrollY = window.scrollY;
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY === 0) {
                setIsSticky(false); // Remove sticky when at the top
            } else if (currentScrollY < lastScrollY) {
                setIsSticky(true); // Apply sticky on scroll up
            } else {
                setIsSticky(false); // Remove sticky on scroll down
            }
            lastScrollY = currentScrollY;
            AOS.refresh();
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const [suggestions, setSuggestions] = useState([]);

    // API call to fetch suggestions
    const fetchSuggestions = async (searchText) => {
        if (searchText.length > 2) { // Fetch only after 3 characters
            try {
                const response = await axios.get(`${APP_URL}/api/search?query=${searchText}`);
                if (response.data.resultcount > 0) {
                    setShowSuggestions(true);
                    setSuggestions(response.data);
                } else {
                    setShowSuggestions(false);
                }
            } catch (error) {
                console.error("Error fetching search results", error);
            }
        } else {
            setSuggestions([]);
        }
    };

    const formik = useFormik({
        initialValues: {
            term: '',
        },
        validationSchema: Yup.object({
            term: Yup.string()
                .required('Please enter keywords.')
                .test('no-url-or-domain', "URL doesn't allowed.", (value) => !/((https?:\/\/)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(:\d+)?(\/[^\s]*)?/g.test(value))
                .test('no-bad-words', 'Please remove bad word/inappropriate language.', (value) => !filter.isProfane(value))
                .test('no-html', 'Please enter valid input.', (value) => !/<\/?[^>]+(>|$)/.test(value))
                .matches(/^[A-Za-z\s_'`–—-]+$/, 'Please enter valid input.')
                .matches(/^[^!@#$%^&*()<>{}[\]\\/+;]+$/, 'Please enter valid input.')
        }),
        onSubmit: async (values, { resetForm }) => {
            try {
                setShowSuggestions(false);
                const result = await axios.post(`${APP_URL}/api/searchword`, values);
                handleClose();
                resetForm();
                navigate('/search', { state: { message: 'Your message has been successfully sent!', fromSubmission: true, result: result.data } });
            } catch (error) {
                toast.error("Something went wrong! Please try after some time!");
                console.error('Error submitting form:', error);
            }
        }
    });

    return (
        <>
            <header className={`header-main ${isSticky ? "header-stick" : ""} ${isMenuOpen ? "mobile-menu-open " : ""}`}>
                <div className="header-inner" data-aos="fade-down" data-aos-duration="800" data-aos-delay="500" >
                    <div className="container-fluid">
                        <div className="header-main-inner">
                            <div className="part-01">
                                <Link to="/" title={Constant?.SITE_NAME}>
                                    <img className="logo-white" src={FrontLogo?.webp} alt={Constant?.SITE_NAME} title={Constant?.SITE_NAME} width={225} height={150} />
                                    <img className="logo-color" src={FrontStickyLogo?.webp} alt={Constant?.SITE_NAME} title={Constant?.SITE_NAME} width={75} height={81} />
                                </Link>
                            </div>
                            <div className={`part-02 navbar-width ${isMenuOpen ? "menu-open" : ""}`}>
                                <nav className="menu">
                                    <div className="menu-header align-items-center text-center justify-content-between">
                                        <Button className="menu-close btn-close" onClick={() => setIsMenuOpen(false)} title="Close">
                                            <MenuClose />
                                        </Button>
                                    </div>
                                    <ul className="brand-nav brand-navbar">
                                        <GetHeaderMenu
                                            menuObj={menuObj}
                                            openSubMenuId={openSubMenuId}
                                            handleSubMenuToggle={handleSubMenuToggle}
                                        />
                                    </ul>
                                    <div className="device-social-share social-icon d-block d-md-none">
                                        <ul className="social-list d-flex d-md-none align-items-center justify-content-center mt-4 p-0">
                                            {
                                                Constant?.SOCIAL_FB_LINK ? (<li>
                                                    <Link to={Constant?.SOCIAL_FB_LINK} title="Follow Us On Facebook" target="_blank"><FacebookIcon /></Link>
                                                </li>) : ''
                                            }
                                            {
                                                Constant?.SOCIAL_TWITTER_LINK ? (<li>
                                                    <Link to={Constant?.SOCIAL_TWITTER_LINK} title="Follow Us On X" target="_blank"><XIcon /></Link>
                                                </li>) : ''
                                            }
                                            {
                                                Constant?.SOCIAL_YOUTUBE_LINK ? (
                                                    <li>
                                                        <Link to={Constant?.SOCIAL_YOUTUBE_LINK} title="Follow Us On YouTube" target="_blank"><YoutubIcon /></Link>
                                                    </li>) : ''
                                            }
                                            {
                                                Constant?.SOCIAL_INSTAGRAM_LINK ? (
                                                    <li>
                                                        <Link to={Constant?.SOCIAL_INSTAGRAM_LINK} title="Follow Us On Instagram" target="_blank"><InstagramIcon /></Link>
                                                    </li>) : ''
                                            }
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                            <div className="part-03">
                                <div className="d-flex align-items-center right-panel">
                                    {/* Mobile Menu Toggle Button */}
                                    <button className="menu-toggle d-xl-none" title="Menu" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                                        <MobileMenu />
                                    </button>
                                    <div className="search-element">
                                        <Link onClick={(e) => handleShow(e)} title="Search">
                                            <i className="icon"> <SearchIcon /> </i>
                                        </Link>
                                        <Offcanvas className="search-offcanvas search-page" show={show} onHide={handleClose} placement="end">
                                            <div className="search-box">
                                                <div className="w-100">
                                                    <Offcanvas.Header>
                                                        <Offcanvas.Title>What are you looking for?</Offcanvas.Title>
                                                        <CloseButton title="Close" onClick={handleClose} />
                                                    </Offcanvas.Header>
                                                    <Offcanvas.Body>
                                                        <Form onSubmit={formik.handleSubmit} id="searching_id" autoComplete="off">
                                                            <InputGroup className="">
                                                                <Form.Control className="search-input mb-1" size="lg" type="text" placeholder="Enter your keywords..." id="term" name="term" value={formik.values.term}
                                                                    onChange={(e) => {
                                                                        formik.handleChange(e);
                                                                        fetchSuggestions(e.target.value);
                                                                    }} onBlur={formik.handleBlur} />

                                                                <button className="btn btn-search" title="Search" type="submit"> <SearchIcon /> </button>
                                                            </InputGroup>
                                                            {formik.touched.term && formik.errors.term && <div className="error">{formik.errors.term}</div>}
                                                            {showSuggestions && (
                                                                <ul className="suggestions-list shadow bg-white text-start p-4 pt-2 list-unstyled rounded-3">
                                                                    {suggestions?.autoSearchResult && suggestions?.autoSearchResult?.map((suggestion, index) => {
                                                                        let urls = '';
                                                                        if (suggestion?.varModuleName == 'pages') {
                                                                            urls = '/' + suggestion?.slug;
                                                                        } else if (suggestion?.varModuleName == 'faq' || suggestion?.varModuleName == 'ourteam') {
                                                                            urls = '/' + suggestion?.pageAlias;
                                                                        } else {
                                                                            urls = '/' + suggestion?.pageAlias + '/' + suggestion?.slug;
                                                                        }
                                                                        return (
                                                                            <li key={index} className="item py-3" >
                                                                                <Link to={urls} onClick={handleClose}>
                                                                                    {suggestion?.term}
                                                                                </Link>
                                                                            </li>
                                                                        )
                                                                    })
                                                                    }
                                                                </ul>
                                                            )}
                                                        </Form>
                                                        <div className="quick-search mt-3">
                                                            <ul>
                                                                <li><strong>Quick Search :</strong></li>
                                                                {Constant?.EVENT_PAGE ? (
                                                                    <li><Link to={APP_URL + '/' + Constant?.EVENT_PAGE} onClick={handleClose} title="Events">Events,</Link></li>
                                                                ) : ''}
                                                                {Constant?.ATTRACTIONS_PAGE ? (
                                                                    <li><Link to={APP_URL + '/' + Constant?.ATTRACTIONS_PAGE} onClick={handleClose} title="Attractions">Attractions,</Link></li>
                                                                ) : ''}
                                                                {Constant?.ACTIVITES_PAGE ? (
                                                                    <li><Link to={APP_URL + '/' + Constant?.ACTIVITES_PAGE} onClick={handleClose} title="Activites">Activites,</Link></li>
                                                                ) : ''}
                                                                {Constant?.CONTACTPAGE ? (
                                                                    <li><Link to={APP_URL + '/' + Constant?.CONTACTPAGE} onClick={handleClose} title="Contacts">Contacts</Link></li>
                                                                ) : ''}
                                                            </ul>
                                                        </div>
                                                    </Offcanvas.Body>
                                                </div>
                                            </div>
                                        </Offcanvas>
                                    </div>
                                    <Link to={APP_URL + '/' + Constant?.CONTACTPAGE} title="Contact Us" className="btn btn-primary btn-contact">
                                        Contact Us
                                    </Link>
                                    <ul className="social-list social-icon d-md-flex d-none align-items-start mb-0 p-0">
                                        <li>
                                            <i className="facebook">
                                                <Link to={Constant?.SOCIAL_FB_LINK} title="Follow Us On Facebook" target="_blank"><FacebookIcon /></Link>
                                            </i>
                                        </li>
                                        <li>
                                            <i className="twitter">
                                                <Link to={Constant?.SOCIAL_TWITTER_LINK} title="Follow Us On X" target="_blank"><XIcon /></Link>
                                            </i>
                                        </li>
                                        <li>
                                            <i className="youtub">
                                                <Link to={Constant?.SOCIAL_YOUTUBE_LINK} title="Follow Us On YouTube" target="_blank"><YoutubIcon /></Link>
                                            </i>
                                        </li>
                                        <li>
                                            <i className="instagram">
                                                <Link to={Constant?.SOCIAL_INSTAGRAM_LINK} title="Follow Us On Instagram" target="_blank"><InstagramIcon /></Link>
                                            </i>
                                        </li>
                                    </ul>
                                </div>
                                <div className="nav-overlay" onClick={() => setIsMenuOpen(false)}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}

function GetHeaderMenu({ menuObj, openSubMenuId, handleSubMenuToggle }) {
    const location = useLocation();
    const segments = location.pathname.split("/").filter(segment => segment);
    const targetSegment = segments[0];
    const isParentActive = (item) => {
        // Check if the current URL matches any child URL
        if (item?.children) {
            return item?.children.some(child => location.pathname.includes(child?.txtPageUrl));
        }
        return location.pathname.includes(item?.txtPageUrl);
    };

    return (
        <>
            {menuObj?.slice(0, 4).map((item, index) => {
                const { id, varTitle, intPageId, txtPageUrl, chrNewTab, children } = item;
                const hasChildren = children?.length > 0;
                const isActive = isParentActive(item);
                const isSubMenuOpen = openSubMenuId === id;
                const [clickedOnce, setClickedOnce] = useState(false); // NEW State for handling first/second click
                const linkProps = {
                    title: varTitle,
                    target: chrNewTab === "Y" ? "_blank" : "_self",
                    className: ({ isActive }) => (isActive || isParentActive(item) ? "active" : ""),
                    onClick: (e) => handleMenuClick(e, id) // Updated onClick
                };

                const handleMenuClick = (e, itemId) => {
                    const isSmallScreen = window.innerWidth == 1333;
                    if (hasChildren && isSmallScreen) {
                        if (openSubMenuId !== itemId) {
                            e.preventDefault(); // Stop navigation
                            handleSubMenuToggle(itemId); // Open submenu
                        }
                        // If submenu already open, allow navigation on second click
                    }
                };
                return (
                    <li key={index} className={`${hasChildren ? "has-children" : ""} ${isActive ? "active" : ""} ${intPageId}`}>
                        {/* Menu Link */}
                        {intPageId === "#" || txtPageUrl === "javascript:;" ? (
                            <div className="cursor-pointer nav-link-a" title={varTitle}>{varTitle}</div>
                        ) : intPageId === null && txtPageUrl !== "javascript:;" ? (
                            <NavLink to={`${txtPageUrl}`} {...linkProps}>{varTitle}</NavLink>
                        ) : (
                            <NavLink to={`/${txtPageUrl}`} {...linkProps}>{varTitle}</NavLink>
                        )}
                        {/* Submenu Toggle Button */}
                        {hasChildren && (
                            <span className={`is-open ${isSubMenuOpen ? "is-close" : ""}`} onClick={() => handleSubMenuToggle(id)}>
                                +
                            </span>
                        )}
                        {/* Submenu */}
                        {hasChildren && (
                            <ul className={`sub-menu ${isSubMenuOpen ? "open" : ""}`}>
                                {children?.map((child, childIndex) => (
                                    <GetChildMenu key={childIndex} MenuObj={child} />
                                ))}
                            </ul>
                        )}
                    </li>
                );
            })}
        </>
    );
}

function GetChildMenu({ MenuObj }) {
    return (
        <li key={MenuObj?.txtPageUrl || Math.random()}>
            {MenuObj?.intPageId ? (
                <NavLink
                    to={`/${MenuObj?.txtPageUrl}`}
                    title={MenuObj?.varTitle}
                    target={MenuObj?.chrNewTab === "Y" ? "_blank" : "_self"}
                >
                    {MenuObj?.varTitle}
                </NavLink>
            ) : (
                <a
                    href={MenuObj?.txtPageUrl}
                    title={MenuObj?.varTitle}
                    target={MenuObj?.chrNewTab === "Y" ? "_blank" : "_self"}
                >
                    {MenuObj?.varTitle}
                </a>
            )}
            {MenuObj?.children && (
                <ul className="sub-menu">
                    {MenuObj?.children?.map((child, index) => (
                        <GetChildMenu key={index} MenuObj={child} />
                    ))}
                </ul>
            )}
        </li>
    );
}

export default Header;